export default "__VITE_ASSET__CLDNu2PM__"